import Skeleton from '../Skeleton';
import { LectureVideoPlayer } from '../video/LectureVideoPlayer';
import { LectureCategory } from '../../lib/types';

export const Video = ({
    slug,
    category,
    posterClassName,
}: {
    slug: string;
    category: LectureCategory;
    posterClassName?: string;
}) => {
    const video = category.lectures?.find((lecture) => lecture.slug === slug);

    return (
        <div className="w-full max-w-[892px] flex-1">
            {video && (
                <LectureVideoPlayer
                    isActive={true}
                    poster={video.video.poster}
                    src={video.video.url}
                    posterClassName={posterClassName}
                />
            )}
            {!video && <Skeleton className="h-40 w-full rounded rounded-xl" />}
        </div>
    );
};
